"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _Caption = _interopRequireDefault(require("../../../text/Caption"));

var _useFootnote = _interopRequireDefault(require("../../../../hooks/useFootnote"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledFlex = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "iblds7-0"
})(["& >:not(:last-child){margin-bottom:8px;}"]);

function FootnoteMessages(_ref) {
  var className = _ref.className;
  var footnotes = (0, _useFootnote["default"])();
  return footnotes && _react["default"].createElement(StyledFlex, {
    className: className,
    flexDirection: "column"
  }, Object.keys(footnotes).map(function (key) {
    var _footnotes$key = footnotes[key],
        symbol = _footnotes$key.symbol,
        message = _footnotes$key.message;
    return _react["default"].createElement(_pclnDesignSystem.Flex, {
      key: key,
      alignItems: "flex-start"
    }, _react["default"].createElement(_Caption["default"], {
      subdued: true,
      mr: 2
    }, symbol), _react["default"].createElement(_Caption["default"], {
      subdued: true
    }, message));
  }));
}

FootnoteMessages.displayName = 'FootnoteMessages';
FootnoteMessages.propTypes = {
  className: _propTypes["default"].string
};
FootnoteMessages.defaultProps = {
  className: ''
};

var _default = (0, _react.memo)(FootnoteMessages);

exports["default"] = _default;